import { BpButton } from '../../buttons/bp-button/BpButton'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { ChangeTariff } from '../change-tariff/ChangeTariff'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import styles from './DetectMoreAds.module.scss'
import clsx from 'clsx'
import { IconDetectMoreAds } from '../../icons/IconDetectMoreAds'
import { IconButton } from '../../buttons/icon-button/IconButton'
import { IconCrossBold } from '../../icons/IconCrossBold'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { selectTariffDetails, selectUser } from '../../../../app/store/reducers/AuthSlice'
import { useMenuLayout } from '../../../../app/layouts/main-layout/hooks/UseMenuLayout'
import { useSidebarExpanded } from '../../../../app/layouts/main-layout/hooks/UseSidebarExpanded'

export const DetectMoreAds = () => {
  const user = useAppSelector(selectUser)
  const tariffDetails = useAppSelector(selectTariffDetails)
  const { menuLayout } = useMenuLayout()
  const { expanded } = useSidebarExpanded()
  const [visible, setVisible] = useState(true)
  const dispatch = useDispatch()

  if (!visible) {
    return null
  }

  if (!localStorage.getItem('detect_more_ads_banner')) {
    return null
  }

  if (!tariffDetails.tariff) {
    return null
  }

  if (tariffDetails.tariff?.type !== 'trial') {
    return null
  }

  if (tariffDetails.tariff?.is_subscription_expired) {
    return null
  }

  if (user.notifications?.find((notification) => notification.type === 'onboarding_tutorial')) {
    return null
  }

  return (
    <div
      className={clsx(
        'fixed bottom-[16px] left-[16px] z-[100] w-full max-w-[340px] rounded-[16px] px-[24px] py-[20px]',
        'transition-[left] duration-150',
        menuLayout === 'sidebar' && (expanded ? 'md:left-[206px]' : 'md:left-[64px]'),
        styles.wrapper,
      )}
    >
      <div className='absolute top-[16px] right-[16px] z-10'>
        <IconButton
          className={'border-none !bg-transparent'}
          onClick={() => {
            setVisible(!visible)
            localStorage.removeItem('detect_more_ads_banner')
          }}
        >
          <IconCrossBold color='#ffffff' />
        </IconButton>
      </div>
      <div className={'flex flex-col gap-[8px] pb-[24px]'}>
        <p className={'text-[18px] font-semibold text-[#FBFF3B]'}>Detect More Unauthorized Ads</p>
        <p className={'font-regular max-w-[250px] text-[15px] text-aqua-300'}>
          Unlock monitoring{' '}
          <span className={'text-white'}>of 100 keywords with 12 daily scans</span> for global
          multi-brand protection.
        </p>
      </div>
      <BpButton
        className={'uppercase'}
        onClick={() =>
          dispatch(setModal({ size: 'full', children: <ChangeTariff />, withBackButton: true }))
        }
      >
        Upgrade now
      </BpButton>
      <div className={'absolute bottom-[-16px] right-[-36px] w-[130px]'}>
        <IconDetectMoreAds />
      </div>
    </div>
  )
}
